var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-code",style:([{ backgroundImage: 'url(' + _vm.bgImg + ')' }])},[_c('div',{staticClass:"code-title text-align"})])])}
var staticRenderFns = []

export { render, staticRenderFns }